<script>
export default {
  name: "breadcrumbLogin"
};
</script>

<template>
  <el-row class="breadcrumb-outer-wrapper">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/homepage' }"
          >Homepage</el-breadcrumb-item
        >
        <el-breadcrumb-item>Login</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
  </el-row>
</template>

<style scoped>
.breadcrumb-outer-wrapper{
  padding: 8px 16px 8px 16px;
  background-color: #003333;
}
.el-breadcrumb__item /deep/ .el-breadcrumb__separator {
  color: #ffffff;
  font-weight: 600;
}

.el-breadcrumb__item /deep/ .el-breadcrumb__inner {
  color: #ffffff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/breadcrumbLogin.vue